<template>
    <div class="intolerance" :class="{ 'is-active': isActive }" @click="select">
        <div class="intolerance__label">{{ title }}</div>
    </div>
</template>

<script>
import { wrapFunction } from '../js/utils.js';

export default {
    name: 'Intolerance',
    computed: wrapFunction(`
        title
        isActive
        name
    `),
    props: {
        data: Object
    },
    methods: {
        select() {
            this.isActive = !this.isActive;
            this.$emit(['deselect', 'select'][Number(this.isActive)]);
        }
    }
}
</script>

<style lang="scss">
@import '../scss/config';


// TODO: clean up
.intolerance {
    $checkbox-size: rem(20);
    $tick-size: $checkbox-size * .66;

    transition-property: background, color;
    font-size: size(font-small) !important;
    position: relative;
    color: color(middleground);

    margin-bottom: $checkbox-size;
    hyphens: auto;

    &::before,
    &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
    }

    &::before {
        width: $checkbox-size;
        height: $checkbox-size;
        border: size(line) solid color(middleground);
    }

    &::after {
        width: ($tick-size / 2);
        height: ($tick-size);
        border-right: size(line) solid color(background);
        border-bottom: size(line) solid color(background);
        transform: rotate(45deg);
        left: ($checkbox-size / 2) - ($tick-size / 4);
        top: ($checkbox-size / 2) - ($tick-size * .66);
    }

    padding-left: $checkbox-size * 1.5;

    &.is-active {
        color: color(accent);

        &::before {
            border-color: color(accent);
            background: color(accent);
        }
    }

    // .intolerances
    &#{s} {
        // @include mono-grid-container();
        $container: &;
        $height: rem(size-plain(huge) - (2 * size-plain(small)));

        transition: max-height $g-transition-duration ease, opacity $g-transition-duration ease;
        columns: 3;
        column-gap: size(medium);
        position: relative;

        #{$container}__wrapper.is-open & {
            height: auto;
            max-height: rem(600);
            opacity: 1;
        }

        &__wrapper {
            border-bottom: size(line) solid color(middleground);

            &.is-open {
                border-bottom-color: color(middleground, $opacity: .44);
            }
        }

        &__submit {
            margin: 0 auto;
            height: 0;
            display: block;
            opacity: 0;
            border-width: 0;
            font-size: size(font-small);

            // TODO maybe show ubtton only when intolerances have been selected?
            // #{$container}__wrapper.is-open.has-selected-items & {
            #{$container}__wrapper.is-open & {
                // fugly
                height: size(grand);
                margin-bottom: size(large);
                opacity: 1;
                border-width: rem(1);
            }
        }

        &__header {
            @include center-children-vertically;

            position: relative;
            margin-bottom: 0;
            transition: margin-bottom $g-transition-duration ease;

            #{$container}__wrapper.is-open & {
               margin-bottom: size(small);
            }
        }

        &__title,
        &__subtitle {
            margin: 0;
        }

        &__title {
            padding-bottom: size(smaller);
            color: color(middleground);

            #{$container}__wrapper.is-open & {
               color: color(foreground);
            }
        }

        &__subtitle {
            font-size: size(small);
            color: color(accent-secondary);
            overflow: hidden;
            line-height: 1;
            display: none;

            &,
            #{$container}__wrapper.is-open.has-selected-items & {
                margin-top: 0;
                height: 0;
                opacity: 0;
            }

            #{$container}__wrapper.has-selected-items & {
                height: size(small);
                margin-top: size(tiny);
                opacity: 1;
            }
        }

        &__toggle {
            $size: rem(16);
            position: absolute;
            right: - rem(15);
            top: - rem(15);
            padding: 0;

            // @include cross-button((
            //     size: $size,
            //     color: color(foreground),
            //     roundness: size(line),
            // ));
        }
    }

    &__label {

    }
}

</style>
